/** Generated js for domain-specific scripting
 * by common\modules\domains\helpers\DomainJavascriptWriter
 */

(function () {
  const root = document.getElementById('kavelselector');
  if (!root) return;

  const wrapper = root.querySelector('.map-wrapper');
  const svg = wrapper.querySelector('svg');

  // Dynamisch alle popups verzamelen op basis van data-id attributen
  const hoverAreas = svg.querySelectorAll('.hover-area');
  const popups = {};
  
  hoverAreas.forEach(area => {
    const id = area.getAttribute('data-id');
    const popup = document.getElementById('popup-' + id);
    if (popup) {
      popups[id] = popup;
    }
  });

  let currentId = null;
  let hideTimer = null;
  let isPinned = false;

  let isDragging = false;
  let dragPopup = null;
  let dragDx = 0;
  let dragDy = 0;

  function closeAll() {
    Object.values(popups).forEach(p => {
      if (p) {
        p.style.display = 'none';
        p.classList.remove('dragging');
      }
    });
    currentId = null;
    isPinned = false;
    isDragging = false;
    dragPopup = null;
  }

  function showOnly(id) {
    Object.entries(popups).forEach(([key, p]) => {
      if (!p) return;
      p.style.display = key === id ? 'block' : 'none';
      if (key !== id) p.classList.remove('dragging');
    });
  }

  function clamp(val, min, max){ return Math.max(min, Math.min(val, max)); }

  function positionPopupAtPoint(popup, clientX, clientY) {
    const wrapRect = wrapper.getBoundingClientRect();
    const x = clientX - wrapRect.left + 14;
    const y = clientY - wrapRect.top + 14;

    popup.style.display = 'block';
    const pw = popup.offsetWidth, ph = popup.offsetHeight;
    const left = clamp(x, 8, wrapRect.width  - pw - 8);
    const top  = clamp(y, 8, wrapRect.height - ph - 8);
    popup.style.left = left + 'px';
    popup.style.top  = top  + 'px';
  }

  function positionPopupAtCoords(popup, left, top) {
    const wrapRect = wrapper.getBoundingClientRect();
    popup.style.display = 'block';
    const pw = popup.offsetWidth, ph = popup.offsetHeight;
    popup.style.left = clamp(left, 8, wrapRect.width  - pw - 8) + 'px';
    popup.style.top  = clamp(top , 8, wrapRect.height - ph - 8) + 'px';
  }

  function scheduleHide(delay = 180) {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => {
      if (!currentId) return;
      const p = popups[currentId];
      if (p) p.style.display = 'none';
      currentId = null;
      isPinned = false;
    }, delay);
  }
  function clearHide() { clearTimeout(hideTimer); }

  function isIntoAnyPopup(node) {
    return Object.values(popups).some(p => p && p.contains(node));
  }
  function isIntoSVG(node) {
    return svg.contains(node);
  }

  // Volg muis op hover zolang niet vastgezet
  svg.addEventListener('mousemove', e => {
    const target = e.target.closest('.hover-area');
    if (!target || isPinned) return;

    const id = target.getAttribute('data-id');
    const popup = popups[id];
    if (!popup) return;

    if (currentId && currentId !== id) {
      const prev = popups[currentId];
      if (prev) prev.style.display = 'none';
    }
    currentId = id;
    clearHide();
    positionPopupAtPoint(popup, e.clientX, e.clientY);
  });

  // Klik op een kavel zet vast en sluit andere pop-ups automatisch
  svg.addEventListener('click', e => {
    const t = e.target.closest('.hover-area');
    if (!t) return;
    const id = t.getAttribute('data-id');
    const popup = popups[id];
    if (!popup) return;

    currentId = id;
    isPinned = true;

    // sluit alle andere pop-ups en toon alleen de huidige
    showOnly(id);

    // plaats op klikpositie
    positionPopupAtPoint(popup, e.clientX, e.clientY);
  });

  svg.addEventListener('mouseleave', e => {
    if (isPinned) return;
    if (isIntoAnyPopup(e.relatedTarget)) return;
    scheduleHide();
  });

  Object.entries(popups).forEach(([id, popup]) => {
    if (!popup) return;

    popup.addEventListener('mouseenter', () => {
      clearHide();
      currentId = id;
    });

    popup.addEventListener('mouseleave', e => {
      if (isPinned) return;
      if (isIntoSVG(e.relatedTarget)) return;
      scheduleHide();
    });

    popup.addEventListener('click', e => {
      if (e.target.matches('[data-close], .btn-close')) {
        popup.style.display = 'none';
        if (currentId === id) currentId = null;
        isPinned = false;
      }
    });

    popup.addEventListener('mousedown', e => {
      if (!isPinned) return;
      if (e.button !== 0) return;
      if (e.target.closest('a, button, input, textarea, select, label')) return;

      const rect = popup.getBoundingClientRect();
      const wrapRect = wrapper.getBoundingClientRect();
      dragDx = e.clientX - rect.left;
      dragDy = e.clientY - rect.top;

      isDragging = true;
      dragPopup = popup;
      popup.classList.add('dragging');
      e.preventDefault();
    });
  });

  document.addEventListener('mousemove', e => {
    if (!isDragging || !dragPopup) return;
    const wrapRect = wrapper.getBoundingClientRect();
    const newLeft = e.clientX - wrapRect.left - dragDx;
    const newTop  = e.clientY - wrapRect.top  - dragDy;
    positionPopupAtCoords(dragPopup, newLeft, newTop);
  });

  document.addEventListener('mouseup', () => {
    if (isDragging && dragPopup) dragPopup.classList.remove('dragging');
    isDragging = false;
    dragPopup = null;
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeAll();
  });

  svg.addEventListener('touchstart', function (e) {
    const t = e.target.closest('.hover-area');
    if (!t) return;
    const id = t.getAttribute('data-id');
    const popup = popups[id];
    if (!popup) return;
    currentId = id;
    isPinned = true;
    const touch = e.touches[0];
    showOnly(id);
    positionPopupAtPoint(popup, touch.clientX, touch.clientY);
  }, {passive: true});
})();

/* Nieuws widget Interactie: muis slepen, wheel naar horizontaal, pijltjes, klikbescherming, keyboard */
(() => {
  const outer = document.getElementById('newsScroller');
  const viewport = document.getElementById('newsViewport');
  if (!outer || !viewport) return;

  const track = viewport.querySelector('.news-track');
  const prev = outer.querySelector('.news-nav.prev');
  const next = outer.querySelector('.news-nav.next');

  /* Stapgrootte is kaartbreedte plus gap */
  const stepSize = () => {
    const card = track.querySelector('.news-card');
    if (!card) return viewport.clientWidth * 0.9;
    const gap = parseFloat(getComputedStyle(track).gap || 16);
    return card.getBoundingClientRect().width + gap;
  };

  /* Pijlen klikken */
  const by = dir => viewport.scrollBy({ left: dir * stepSize(), behavior: 'smooth' });
  prev?.addEventListener('click', () => by(-1));
  next?.addEventListener('click', () => by(1));

  /* Keyboard op de focusbare viewport */
  viewport.addEventListener('keydown', e => {
    if (e.key === 'ArrowRight'){ e.preventDefault(); by(1); }
    if (e.key === 'ArrowLeft'){ e.preventDefault(); by(-1); }
  });

  /* Wheel naar horizontaal voor touchpads en muiswiel */
  const wheelToX = e => {
    if (Math.abs(e.deltaY) > Math.abs(e.deltaX)){
      e.preventDefault();
      viewport.scrollLeft += e.deltaY;
    }
  };
  viewport.addEventListener('wheel', wheelToX, { passive:false });
  track.addEventListener('wheel', wheelToX, { passive:false });

  /* Desktop drag met pointer events. Touch gebruikt native scroll. */
  let down = false, startX = 0, startLeft = 0, moved = false;
  const isMouse = e => e.pointerType === 'mouse' || e.pointerType === undefined;

  viewport.addEventListener('pointerdown', e => {
    if (!isMouse(e)) return;
    down = true; moved = false;
    startX = e.clientX;
    startLeft = viewport.scrollLeft;
    viewport.classList.add('is-dragging');
    viewport.setPointerCapture?.(e.pointerId);
    e.preventDefault();
  });
  viewport.addEventListener('pointermove', e => {
    if (!down) return;
    const dx = e.clientX - startX;
    if (Math.abs(dx) > 3) moved = true;
    viewport.scrollLeft = startLeft - dx;
  });
  const endDrag = e => {
    if (!down) return;
    down = false;
    viewport.classList.remove('is-dragging');
    viewport.releasePointerCapture?.(e.pointerId);
  };
  viewport.addEventListener('pointerup', endDrag);
  viewport.addEventListener('pointerleave', endDrag);

  /* Klikbescherming zodat een drag geen link activeert */
  viewport.addEventListener('click', e => {
    if (moved) e.preventDefault();
  }, true);

  /* Pijlstatus bijwerken en clipping voorkomen aan het eind */
  const updateArrows = () => {
    const max = viewport.scrollWidth - viewport.clientWidth - 1;
    if (prev) prev.disabled = viewport.scrollLeft <= 0;
    if (next) next.disabled = viewport.scrollLeft >= max;
  };
  viewport.addEventListener('scroll', updateArrows, { passive:true });
  window.addEventListener('resize', updateArrows);
  updateArrows();
})();

/* BeforeAfter */


class BeforeAfter {
    constructor(enteryObject) {

        const beforeAfterContainer = document.querySelector(enteryObject.id);
        const before = beforeAfterContainer.querySelector('.bal-before');
        const beforeText = beforeAfterContainer.querySelector('.bal-beforePosition');
        const afterText = beforeAfterContainer.querySelector('.bal-afterPosition');
        const handle = beforeAfterContainer.querySelector('.bal-handle');
        var widthChange = 0;

        beforeAfterContainer.querySelector('.bal-before-inset').setAttribute("style", "width: " + beforeAfterContainer.offsetWidth + "px;")
        window.onresize = function () {
            beforeAfterContainer.querySelector('.bal-before-inset').setAttribute("style", "width: " + beforeAfterContainer.offsetWidth + "px;")
        }
        before.setAttribute('style', "width: 50%;");
        handle.setAttribute('style', "left: 50%;");

        //touch screen event listener
        beforeAfterContainer.addEventListener("touchstart", (e) => {

            beforeAfterContainer.addEventListener("touchmove", (e2) => {
                let containerWidth = beforeAfterContainer.offsetWidth;
                let currentPoint = e2.changedTouches[0].clientX;

                let startOfDiv = beforeAfterContainer.offsetLeft;

                let modifiedCurrentPoint = currentPoint - startOfDiv;

                if (modifiedCurrentPoint > 10 && modifiedCurrentPoint < beforeAfterContainer.offsetWidth - 10) {
                    let newWidth = modifiedCurrentPoint * 100 / containerWidth;

                    before.setAttribute('style', "width:" + newWidth + "%;");
                    afterText.setAttribute('style', "z-index: 1;");
                    handle.setAttribute('style', "left:" + newWidth + "%;");
                }
            });
        });

        //mouse move event listener
        beforeAfterContainer.addEventListener('mousemove', (e) => {
            let containerWidth = beforeAfterContainer.offsetWidth;
            widthChange = e.offsetX;
            let newWidth = widthChange * 100 / containerWidth;

            if (e.offsetX > 10 && e.offsetX < beforeAfterContainer.offsetWidth - 10) {
                before.setAttribute('style', "width:" + newWidth + "%;");
                afterText.setAttribute('style', "z-index:" + "1;");
                handle.setAttribute('style', "left:" + newWidth + "%;");
            }
        })

    }
}

/* expander */
if (document.querySelector('#beforeafterslider')) {
  new BeforeAfter({ id: '#beforeafterslider' });
}

document.addEventListener('click', function (event) {
  const isExpandButton =
    event.target.matches('.expand-button') ||
    event.target.closest('.expand-button') !== null;

  const expanderParent = event.target.closest('.expander');

  if (isExpandButton && expanderParent) {
    event.preventDefault();
    toggleExpander(expanderParent, true);
  }
});

function toggleExpander(expanderElement, toggle) {
  if (toggle) {
    expanderElement.classList.toggle('expand');
  }
  let maxHeight = '999em';
  if (!expanderElement.classList.contains('expand')) {
    maxHeight = expanderElement.dataset.minimalHeight ?? '50px';
  }
  const contentElement = expanderElement.querySelector('.expander-content');
  if (contentElement) {
    contentElement.style.maxHeight = maxHeight;
  }
}

document.querySelectorAll('.expander').forEach(expander => {
  toggleExpander(expander, false);
});